"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.en = void 0;
exports.en = {
  "consentSettings": {
    "acceptSelected": "Accept Selected",
    "title": "Settings",
    "description": "Here you can adjust your settings for the use of external services.",
    "disableAll": {
      "title": "Enable/Disable all Services",
      "description": "Use this switch to enable or disable all services."
    },
    "info": "Info",
    "showServices": "Show Services",
    "close": "Close",
    "save": "Save",
    "acceptAll": "Accept all",
    "decline": "Decline",
    "optOut": {
      "description": "This service is activated by default, but can be deactivated at any time.",
      "title": "(opt-out)"
    },
    "contextOnly": {
      "description": "This service can only be activated in the context of the blocked element on the page.",
      "title": "(contextual Consent)"
    },
    "required": {
      "description": "This service is required and cannot be deactivated.",
      "title": "(required)"
    }
  },
  "consentNotice": {
    "acceptSelected": "Accept Selected",
    "changeDescription": "There were changes since your last visit, please renew your consent.",
    "description": "You can change your settings at any time. We use third-party services for:",
    "consentSettingsLink": "Settings",
    "title": "We use Cookies",
    "acceptAll": "Accept all",
    "decline": "Decline"
  },
  "language": "Language",
  "languageName": "English",
  "attribution": {
    title: "Consent by Bryn",
    url: "https://brynlabs.com/consent"
  },
  "privacyPolicy": {
    "title": "Privacy Policy",
    url: ""
  },
  "purposes": {
    "advertising": {
      "description": "These services process personal information to show you personalized or interest-based advertisements.",
      "title": "Advertising"
    },
    "analytics": {
      "description": "These services process personal information to help us understand our users and improve this website.",
      "title": "Analytics"
    },
    "functionality": {
      "description": "These services are essential for the correct functioning of this website. You cannot disable them here as the service would not work correctly otherwise.",
      "title": "Functionality"
    },
    "personalisation": {
      "description": "These services process personal information to optimize the service that this website offers.",
      "title": "Personalisation"
    },
    "security": {
      "description": "These services enable user authentication, fraud prevention and other user protection measures.",
      "title": "Security"
    },
    "other": {
      "description": "Other services that have not been categorized any further.\n",
      "title": "Other"
    }
  },
  "readingDirection": "ltr"
};